import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import MessagePriorityService from "../../src/Services/MessagePriority.service";
const MessagePriorityLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return MessagePriorityService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return MessagePriorityService.searchAll(search);
        },
        optionRenderer: function optionRenderer(messagePriority) {
            return _jsx("span", { children: messagePriority.name });
        },
    });
};
export default MessagePriorityLookup;
